export const SET_PLAYER_OPEN = 'SET_PLAYER_OPEN';
export const SET_FLOAT_MODE = 'SET_FLOAT_MODE';
export const SET_PAGE_LOADED = 'SET_PAGE_LOADED';
export const SET_INIT_PAGE_MODE = 'SET_INIT_PAGE_MODE';
export const SET_COORDINATES = 'SET_COORDINATES';
